module.exports = __webpack_public_path__ + "img/TAXlogo.e5909033.svg";